<template>
  <section class="customcheckerboard-wrap-selector">
    <div :class="[
      'customcheckerboard-wrap-selector-body',
      'customcheckerboard-main-views-wrapper-body'
    ]">
      <h5
        :class="[
          'customcheckerboard-wrap-selector-title',
          'customcheckerboard-main-views-wrapper-title',
          'text-center',
        ]">{{ translations.customCheckerboardWarpTitle }}</h5>
      <div class="customcheckerboard-wrap-selector-container" v-if="canvasLoaded">
        <div
            class="customcheckerboard-wrap-selector-item"
            v-for="(item, warp) in warps"
            :key="warp"
          >
          <div
            :class="[
              'customcheckerboard-wrap-selector-image',
              {'customcheckerboard-wrap-selector-image-active': warp === selectedWarp}
            ]"
            :style="{backgroundColor: $store.state.customCheckerboard.canvasConfig.color1}"
          >
            <div
              v-show="warp === selectedWarp"
              class="customcheckerboard-size-selector-icon-check icon-check"
            ></div>
            <warp-glfx
              :warp-info="item"
              :warp-name="warp"
              :is-selected="warp === selectedWarp"
              @warpSelected="warpSelected"
              @warpLoaded="warpLoaded"
            ></warp-glfx>
          </div>
          <span class="customcheckerboard-wrap-selector-label">{{ translations[item.label] }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import warpGlfx from './WarpGlfx';
import { warps } from './warpSettings';

export default {
  name: "checkerboardWarpSelector",
  props: {
    isMainApp: {
      type: Boolean,
      default: false
    }
  },
  components: {
    warpGlfx
  },
  props: {
    canvasLoaded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  data() {
    return {
      selectedWarp: null,
      warpsGlfxComponents: 0,
      warps
    };
  },
  methods: {
    /**
     * @function warpSelected
     * Event that will save the warpped image that is emitted in warpGlfx child component
     */
    warpSelected(placementImage, warpName) {
      // If the maincomponent is destroyed the refs will be undefined
      // This is useful when the user close out the modal
      const { activeUGCComponent : activeComponent} = this.$store.state.customCheckerboard;
      const componentName = activeComponent || "";
      if (!this.$parent.$refs[`warpImage${componentName}`]) return;
      this.selectedWarp = warpName;
      this.$store.commit('customCheckerboard/SET_CANVAS_CONFIG', { warp: this.selectedWarp });
      this.$store.commit('customCheckerboard/SET_COMPONENT_CONFIG', {
        component: componentName,
        canvasConfig: this.$store.state.customCheckerboard.canvasConfig
      });
      this.$parent.$refs[`warpImage${componentName}`][0].src = placementImage;
    },
    warpLoaded() {
      this.warpsGlfxComponents++;
      if (this.warpsGlfxComponents == Object.keys(this.warps).length) {
        this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", true);
      }
    },
    /**
     * Sets the CSS property/variable `--vh` used to fix the CSS `vh` unit on Safari
     *
     * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
     */
    setVhProperty() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${ vh }px`);
    },
  },
  created() {
    this.selectedWarp = this.$store.state.customCheckerboard.canvasConfig.warp;
    // When the user comes from confirm view the canvas is already loaded
    // the controls should be enabled.
    // If the user comes from size selector the commit is made in main-views
    // component since the warpGlfx should be wait until the canvas is render
    // in the DOM.
    if (this.$props.canvasLoaded) {
      this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", true);
    }
    this.setVhProperty();
    window.addEventListener('resize', this.setVhProperty);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVhProperty);
  },
};
</script>